// extracted by mini-css-extract-plugin
module.exports = {"AnimatedMouse":"AnimatedMouse_AnimatedMouse__1Vkfa","Text":"AnimatedMouse_Text__3uge6","Mouse":"AnimatedMouse_Mouse__21CLG","MouseAnimation":"AnimatedMouse_MouseAnimation__2Sp51"};